import React, { Component } from 'react';
import _ from 'lodash';
import DataList from 'components/ui/DataList';
import DataPoller from 'components/ui/DataPoller';
import CargomaticInput from 'components/v2/input';
import AccessorialRequestActionCreators from 'actions/AccessorialRequestActionCreators';
import ExceptionStore from 'stores/ExceptionStore';
import SessionStore from 'stores/SessionStore';
import { withTranslation } from 'react-i18next';
import AccessorialsMapping from './AccessorialMapping';
import Alert from '../../ui/Alert';
import Container from '../../v2/container';
class AccessorialModule extends Component {
    constructor(props) {
        super(props);
        this.onChange = () => {
            const result = ExceptionStore.getAllAccessorialPaginatedRequests();
            let { items: exceptions, totalCount, totalPages, } = result;
            exceptions = exceptions.map((exception) => {
                const currentException = this.state.exceptions.find((exc) => exc._id === exception._id);
                return Object.assign(Object.assign({}, exception), { toggleDeclineAccept: this.toggleDeclineAccept.bind(this), handleComment: this.handleComment.bind(this), acceptChecked: currentException
                        ? currentException.acceptChecked
                        : false, declineChecked: currentException
                        ? currentException.declineChecked
                        : false });
            });
            this.setState({ exceptions, totalCount, totalPages });
        };
        this.handleComment = (value, accessorialId) => {
            const { updates } = this.state;
            let update = _.find(updates, { _id: accessorialId });
            if (!update) {
                update = { _id: accessorialId, admin_note: value };
                updates.push(update);
            }
            else {
                update.admin_note = value;
            }
            this.setState({ updates });
        };
        this.toggleDeclineAccept = (event, toAccept, accessorialId) => {
            const { exceptions } = this.state;
            const exception = _.find(exceptions, { _id: accessorialId });
            if (exception) {
                this.setCheckedStatus(exception, toAccept, event);
                this.setState({ exceptions });
            }
        };
        this.setCheckedStatus = (update, toAccept, event) => {
            if (toAccept) {
                update.acceptChecked = event.target.checked;
                if (update.acceptChecked) {
                    update.declineChecked = false;
                }
            }
            else {
                update.declineChecked = event.target.checked;
                if (update.declineChecked) {
                    update.acceptChecked = false;
                }
            }
        };
        this.toAccept = (cell, row) => {
            return this.checkBoxFormatter(cell, row, true);
        };
        this.toDecline = (cell, row) => {
            return this.checkBoxFormatter(cell, row, false);
        };
        this.checkBoxFormatter = (_cell, row, acceptChecked) => {
            return (React.createElement("input", { type: "checkbox", label: null, checked: acceptChecked ? row.acceptChecked : row.declineChecked, onChange: (event) => {
                    this.toggleDeclineAccept(event, acceptChecked, row === null || row === void 0 ? void 0 : row._id);
                } }));
        };
        this.commentFormatter = (_cell, row) => {
            const { t } = this.props;
            return (React.createElement(CargomaticInput, { type: "text", hideLabel: true, placeholder: t('COMMENT'), onChange: (value) => {
                    this.handleComment(value, row._id);
                } }));
        };
        this.getAccessorialsMappingColumns = () => {
            var _a;
            return (_a = AccessorialsMapping === null || AccessorialsMapping === void 0 ? void 0 : AccessorialsMapping.columns) === null || _a === void 0 ? void 0 : _a.map((col) => {
                if (col.dataField === 'acceptChecked') {
                    return Object.assign(Object.assign({}, col), { formatter: this.toAccept });
                }
                if (col.dataField === 'declineChecked') {
                    return Object.assign(Object.assign({}, col), { formatter: this.toDecline });
                }
                if (col.dataField === 'comment') {
                    return Object.assign(Object.assign({}, col), { formatter: this.commentFormatter });
                }
                return col;
            });
        };
        this.state = {
            filters: {
                per_page: 25,
                paginate: true,
                page: 1,
            },
            totalCount: 0,
            totalPages: 0,
            updates: [],
            exceptions: [],
            polling_frequency: 5000,
        };
    }
    componentDidMount() {
        ExceptionStore.addChangeListener(this.onChange);
        AccessorialRequestActionCreators.getAccessorialRequests(this.getRequest());
    }
    componentWillUnmount() {
        ExceptionStore.removeChangeListener(this.onChange);
    }
    getRequest() {
        if (SessionStore.isAdmin() || SessionStore.isCarrier()) {
            return {
                shipper_status: 'pending-shipper',
                payee_type: 'carrier',
            };
        }
        return Object.assign({ shipper_status: 'pending-shipper', shipper: SessionStore.getUser()._id }, this.state.filters);
    }
    handlePaginationSelect(page) {
        this.setState((prevState) => {
            const filters = prevState.filters;
            filters.page = page;
            return {
                selected: [],
                filters,
                page,
            };
        }, () => {
            AccessorialRequestActionCreators.getAccessorialRequests(this.getRequest());
        });
    }
    submitAll() {
        const { exceptions, updates } = this.state;
        const accepts = _.filter(exceptions, (ex) => ex.acceptChecked);
        const declines = _.filter(exceptions, (ex) => ex.declineChecked);
        if (accepts.length) {
            const payload = {
                accessorials: accepts.map((acc) => {
                    return { _id: acc._id, shipment: acc.shipment };
                }),
                resolution_type: 'accept',
                sendEmail: true,
            };
            AccessorialRequestActionCreators.acceptAccessorials(payload);
        }
        if (declines.length) {
            const payload = declines.map((dec) => {
                const update = _.find(updates, (up) => up._id === dec._id) || {};
                return {
                    _id: dec._id,
                    shipper_status: 'declined',
                    resolution_type: 'decline',
                    admin_note: update.admin_note || '',
                };
            });
            AccessorialRequestActionCreators.updateAccessorialRequest(payload);
        }
    }
    renderSubmitButton() {
        const { t } = this.props;
        const { exceptions } = this.state;
        const selectedItems = _.filter(exceptions, (update) => update.acceptChecked || update.declineChecked);
        return (React.createElement("div", { className: "flex items-baseline justify-end p-4" },
            React.createElement("button", { type: "button", className: "button button-green", disabled: !selectedItems.length, onClick: () => this.submitAll() },
                React.createElement("span", null, t('SUBMIT')))));
    }
    render() {
        const { t } = this.props;
        const { exceptions, polling_frequency } = this.state;
        if (!SessionStore.isAdmin() && !SessionStore.isShipper()) {
            return (React.createElement("div", { className: "p-4" },
                React.createElement(Alert, { title: t('REQUIRE_PERMISSION_TO_VIEW_PAGE'), type: "error" })));
        }
        return (React.createElement(Container, { className: "py-8 overflow-y-auto" },
            React.createElement("h3", { className: "my-0 mb-4" }, t('ACCESSORIAL_REQUESTS')),
            React.createElement(DataPoller, { action: () => {
                    AccessorialRequestActionCreators.getAccessorialRequests(this.getRequest());
                }, frequency: polling_frequency }),
            React.createElement(DataList, { striped: true, showHeaders: true, paginate: true, total: this.state.totalCount, pages: this.state.totalPages, page: this.state.filters.page, perPage: this.state.filters.per_page, onPaginationSelect: (page) => this.handlePaginationSelect(page), data: exceptions, columns: this.getAccessorialsMappingColumns(), noDataIndication: t('ACCESSORIAL_REQUESTS_NOT_FOUND') }),
            this.renderSubmitButton()));
    }
}
export default withTranslation()(AccessorialModule);
